import URI from 'jsuri';
import Q from 'q';

import API from 'js/lib/api';

const getGradebooksAPI = () => API(`/api/gradebooks.v3`, { type: 'rest' });

const getParams = [
  'createdAt',
  'creatorId',
  'userGradebooks',
  'itemNames',
  'gradedAssignmentGroups',
  'version',
  'status',
  'draftCreatorProfileNames',
  'courseId',
];
const updateParams = ['version', 'status', 'createdAt', 'creatorId', 'userGradebooks'];

const getGradebookAPIUtil = (groupId: string, partnerId?: string, itemId?: string) => {
  if (!groupId) {
    return Q();
  }

  const uri = new URI(groupId).addQueryParam('fields', getParams.join(','));

  if (partnerId) {
    // this is used to get the bulkImportExternalId which is used for Gradebook Imports
    uri.addQueryParam('partnerId', partnerId);
  }

  if (itemId) {
    uri.addQueryParam('itemIds', itemId);
  }

  return Q(
    getGradebooksAPI()
      .get(uri.toString())
      .then((result) => result.elements[0])
  );
};

const updateGradebookAPIUtil = (groupId: string, data: any) => {
  const uri = new URI(groupId).addQueryParam('fields', updateParams.join(','));

  return Q(
    getGradebooksAPI()
      .patch(uri.toString(), { data })
      .then((result) => result.elements[0])
  );
};

const hideGradebookAPIUtil = (groupId: string, version: string, itemId: string, isHidden: boolean) => {
  const uri = new URI()
    .addQueryParam('action', 'applyHidden')
    .addQueryParam('id', groupId)
    .addQueryParam('version', version)
    .addQueryParam('itemId', itemId)
    .addQueryParam('isHidden', isHidden.toString());

  return Q(getGradebooksAPI().post(uri.toString()));
};

const releaseGradebookAPIUtil = (groupId: string, userGradebookReleases: any) => {
  const uri = new URI().addQueryParam('action', 'release').addQueryParam('id', groupId);

  return Q(getGradebooksAPI().post(uri.toString(), { data: { userGradebookReleases } }));
};

const revertDraftGradebookAPIUtil = (groupId: string, userGradebookReverts: any) => {
  const uri = new URI()
    .addQueryParam('action', 'revert')
    .addQueryParam('groupId', groupId)
    .addQueryParam('version', '1');

  return Q(getGradebooksAPI().post(uri.toString(), { data: { userGradebookReverts } }));
};

const exported = {
  getGradebookAPIUtil,
  updateGradebookAPIUtil,
  hideGradebookAPIUtil,
  releaseGradebookAPIUtil,
  revertDraftGradebookAPIUtil,
};

export default exported;
export {
  getGradebookAPIUtil,
  updateGradebookAPIUtil,
  hideGradebookAPIUtil,
  releaseGradebookAPIUtil,
  revertDraftGradebookAPIUtil,
};
